export default class Transferencia {
    
    constructor(model){

        this.bancoOrigemId = 0;
        this.bancoDestinoId = 0;
        this.data = new Date().yyyymmdd();
        this.valor = 0;
        this.descricao = '';
        this.identificada = false;

        if (!model)
            return;
    
        this.id = model.id ? model.id : 0;
        this.bancoOrigemId = model.bancoOrigemId;
        this.bancoDestinoId = model.bancoDestinoId;
        this.data = model.data;
        this.valor = model.valor;
        this.descricao = model.descricao;
        this.identificada = model.identificada;

    }
}